import { isAxiosError } from 'axios';
import { CommonError, CommonErrorResponse } from 'shared/api/types';
import { i18n } from 'shared/lib/i18n';
import { addToast, ToastType, type TranslatableText } from 'shared/model/toast';

const ignoredStatusCodes = [401, 403];

export function handleRequestError(error: Error | CommonError, toastType: ToastType = 'critical'): void {
  if (isAxiosError<CommonErrorResponse>(error)) {
    const status = error.response?.status ?? -1;
    if (ignoredStatusCodes.includes(status)) {
      return;
    }
    // handle axios error
    const errorResponse = error.response?.data;
    if (errorResponse) {
      const { service, code, message } = errorResponse;
      const translationText: TranslatableText = `Exception:${service}.${code}`;

      const isValid = i18n.exists(translationText);

      let description: TranslatableText = message ?? 'Exception:UNDEFINED_ERROR';

      if (isValid) {
        description = translationText;
      }

      addToast({
        type: toastType,
        method: 'error',
        message: 'Exception:REQUEST_ERROR.title',
        description,
      });
      return;
    }
  }

  let errorMessage = '';

  if (error instanceof Error) {
    errorMessage = error.message ?? '';
  } else {
    errorMessage = 'Exception:UNDEFINED_ERROR';
  }

  addToast({
    type: 'critical',
    method: 'error',
    message: 'Exception:UNEXPECTED_ERROR.title',
    description: errorMessage,
  });
}
